import { Heading2Med, Heading4Book, Icon } from '@hai/ui-react';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { apiClientWithoutHandler } from 'src/js/api';
import { APIPath } from 'src/js/api/route-path-index';
import { useStores } from 'src/js/hook/use-stores';
import { clearAllNotifications } from 'src/js/notification/notification-helper';
import { defaultRoute } from 'src/js/route';
import { trunk } from 'src/js/service/persistence';
import { watchStoresEmptyCollections } from 'src/js/store/watch';

export const Rebooting: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { sessionStore } = useStores();

  const checkStatusApi = () => {
    apiClientWithoutHandler.rawController.get(APIPath.status.get).then((res: any) => {
      if (!res.ok && res.status === 401) {
        // reboot completed
        sessionStore.logout();
        trunk.persist();
        navigate(defaultRoute);
      }
    });
  };

  // execute the status task every 5 seconds
  // if there is an error, it means the device has not reboot yet. Nothing happens.
  // if it's successful, we should get an unauthorized response, so the user will be redirected to login.
  useEffect(() => {
    const statusTaskIntervalId = setInterval(() => {
      checkStatusApi();
    }, 5000);

    // clear local stores (streams, accounts, etc)
    watchStoresEmptyCollections();

    clearAllNotifications();

    return () => {
      clearInterval(statusTaskIntervalId);
    };
  }, []);

  return (
    <div className="rebooting">
      <Icon className="aqua-svg" iconname="StatusLoading" spinning size={'lg2'} />
      <Heading2Med>{t('reboot.header')}</Heading2Med>
      <Heading4Book>{t('reboot.subheader')}</Heading4Book>
    </div>
  );
};
